<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="Quel montant souhaitez-vous investir ?"
                    [derrors]="derrors"
                  >
                    <input
                      notdot
                      formControlName="realEstateInsvestmentAmount"
                      type="number"
                      placeholder="Exemple : 100 000€"
                    />
                  </pr-input-column>
                </div>
              </div>
              @if (isPleineProprieteCredit) {
                <div class="row">
                  <div class="col col-md-4">
                    <pr-input-column
                      label="Nom de la banque"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="realEstateLoanBankName"
                        type="text"
                      />
                    </pr-input-column>
                  </div>
                  <div class="col col-md-4">
                    <pr-input-column
                      label="Montant à crédit"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="realEstateLoanAmount"
                        type="number"
                        fraction="2"
                      />
                      <i>€</i>
                    </pr-input-column>
                  </div>
                  <div class="col col-md-4">
                    <pr-input-column
                      label="Apport personnel sur le crédit"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="realEstateLoanApportAmount"
                        type="number"
                        fraction="2"
                      />
                      <i>€</i>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Durée du crédit"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="realEstateLoanMonthDuration"
                        type="number"
                      />
                      <i>Mois</i>
                    </pr-input-column>
                  </div>
                  <div class="col col-md-6">
                    <pr-input-column
                      label="Mensualité du crédit"
                      [derrors]="derrors"
                    >
                      <input
                        formControlName="realEstateLoanMonthlyAmount"
                        type="number"
                        fraction="2"
                      />
                      <i>€/mois</i>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div class="col col-md-6">
                    <pr-input-percent
                      label="Taux d’emprunt"
                      [derrors]="derrors"
                      formControlName="realEstateLoanRate"
                      [suffix]="'%'"
                      min="0"
                      max="100"
                      fraction="2"
                    ></pr-input-percent>
                  </div>
                  <div class="col col-md-6">
                    <pr-input-percent
                      label="Taux d’assurance"
                      [derrors]="derrors"
                      formControlName="realEstateLoanInsuranceRate"
                      [suffix]="'%'"
                      min="0"
                      max="100"
                      fraction="2"
                    ></pr-input-percent>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
